import {
  GO_BACK_ICON_BUTTON_CLASS_NAME,
  NAVBAR_PROFILE_BUTTON_CLASS_NAME,
} from '../../constants/icon-button';
import FingoMuiIconButton from '../../fingo/components/MuiIconButton';

const goBackIconButton = ({ theme }) => ({
  width: 24,
  height: 24,
  '& .MuiSvgIcon-root': {
    color: theme.palette.secondary.main,
  },
  [theme.breakpoints.up('md')]: {
    width: 36,
    height: 36,
  },
});

const navbarProfileButton = ({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  padding: 0,
  width: 32,
  height: 32,
  '&:hover': { backgroundColor: theme.palette.secondary.main },
  '& .MuiSvgIcon-root': {
    padding: 0,
  },
});

const MuiIconButton = {
  ...FingoMuiIconButton,
  styleOverrides: {
    ...FingoMuiIconButton.styleOverrides,
    root: ({ theme }) => ({
      ...FingoMuiIconButton.styleOverrides.root({ theme }),
      [`&.${GO_BACK_ICON_BUTTON_CLASS_NAME}`]: goBackIconButton({ theme }),
      [`&.${NAVBAR_PROFILE_BUTTON_CLASS_NAME}`]: navbarProfileButton({ theme }),
    }),
  },
};

export default MuiIconButton;
